/**
 * Balance Trend Service
 *
 * API client for balance history trend endpoints.
 * Used to fetch sparkline data for account rows.
 */

import { fetchApi } from '@/shared/services';
import type { AccountBalanceTrend } from '@/shared/types';

export const balanceTrendService = {
  /**
   * Get balance trends for a set of accounts.
   * Returns data points suitable for sparkline charts.
   */
  getTrends: (params: {
    account_ids?: string[];
    days?: number;
    household?: boolean;
    user_id?: string;
  }) => {
    const searchParams = new URLSearchParams();
    if (params.account_ids?.length) {
      for (const id of params.account_ids) {
        searchParams.append('account_ids', id);
      }
    }
    if (params.days) searchParams.set('days', String(params.days));
    if (params.household) searchParams.set('household', 'true');
    if (params.user_id) searchParams.set('user_id', params.user_id);
    const qs = searchParams.toString();
    return fetchApi<AccountBalanceTrend[]>(`/balance-history/trend${qs ? `?${qs}` : ''}`);
  },
};
